import { render } from "./requestItem.vue?vue&type=template&id=20509ec9&scoped=true"
import script from "./requestItem.vue?vue&type=script&lang=js"
export * from "./requestItem.vue?vue&type=script&lang=js"

import "./requestItem.vue?vue&type=style&index=0&id=20509ec9&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20509ec9"]])

export default __exports__